module.exports = __webpack_public_path__ + "static/media/NewIngredient2024_en.1a41eb1d.png";